'use client';

import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

type Content = Record<string, any>;

interface PageTextContentData<T extends Content> {
  content: T;
}

const PageTextContentContext = createContext({} as PageTextContentData<any>);

interface Props<T> extends PropsWithChildren {
  content: T;
}

export const PageTextContentContextProvider = <T extends Content>(
  props: Props<T>,
) => {
  const { children, content } = props;

  const value = useMemo(() => ({ content }), [content]);

  return (
    <PageTextContentContext.Provider value={value}>
      {children}
    </PageTextContentContext.Provider>
  );
};

type UsePageTextContent = <T extends Content>() => PageTextContentData<T>;

export const usePageTextContent: UsePageTextContent = () =>
  useContext(PageTextContentContext);
